import { api } from './api';
import { nav } from './nav';
import { routes } from './routes';

export const config = (VITE_MODE?: string) =>
    ({
        app: {
            url: 'http://localhost:5173',
            base_title: 'Qapline IS',
        },
        api: api(VITE_MODE),
        routes,
        nav,
    }) as const;

// Runtime-configurable singleton with safe defaults. This lets apps set the
// active mode (e.g., via VITE_MODE) at startup without putting env logic here.
export type TConfig = ReturnType<typeof config>;
let CURRENT_CONFIG: TConfig = config();

// Backwards-compatible export; remains a live binding that updates when
// setConfigMode is called.
export let DEFAULT_CONFIG: TConfig = CURRENT_CONFIG;

export const getConfig = (): TConfig => CURRENT_CONFIG;

export const setConfigMode = (mode?: string) => {
    CURRENT_CONFIG = config(mode);
    DEFAULT_CONFIG = CURRENT_CONFIG;
};
